export default __webpack_public_path__ + "static/media/Insight_data_tableau_récap_15.aeae75e3.svg";